import React, { useState } from 'react';
import {
  Paper,
  Grid,
  TextField,
  Typography,
  Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { es } from 'date-fns/locale';

const useStyles = makeStyles((theme) => ({
  filterContainer: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 'bold'
  },
  errorText: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(1)
  }
}));

const DateRangeFilter = ({ onChange, initialStart, initialEnd }) => {
  const classes = useStyles();
  const [startDate, setStartDate] = useState(initialStart || null);
  const [endDate, setEndDate] = useState(initialEnd || null);
  const [error, setError] = useState('');

  const handleStartDateChange = (date) => {
    setStartDate(date);
    
    // Validar que start <= end
    if (date && endDate && date > endDate) {
      setError('La fecha de inicio no puede ser posterior a la fecha de fin');
      return;
    }
    
    setError('');
    onChange(date, endDate);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    
    // Validar que start <= end
    if (startDate && date && startDate > date) {
      setError('La fecha de fin no puede ser anterior a la fecha de inicio');
      return;
    }
    
    setError('');
    onChange(startDate, date);
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
      <Paper className={classes.filterContainer}>
        <Typography variant="h6" className={classes.title}>
          Filtrar por Rango de Fechas
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <DatePicker
              label="Fecha de Inicio"
              value={startDate}
              onChange={handleStartDateChange}
              format="dd/MM/yyyy"
              clearable
              fullWidth
              inputVariant="outlined"
              TextFieldComponent={TextField}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DatePicker
              label="Fecha de Fin"
              value={endDate}
              onChange={handleEndDateChange}
              format="dd/MM/yyyy"
              clearable
              fullWidth
              inputVariant="outlined"
              TextFieldComponent={TextField}
            />
          </Grid>
        </Grid>
        {error && (
          <Box mt={1}>
            <Typography variant="body2" className={classes.errorText}>
              {error}
            </Typography>
          </Box>
        )}
      </Paper>
    </MuiPickersUtilsProvider>
  );
};

export default DateRangeFilter;
